import type { PageMeta } from '#app'
import type { NavigationGuard } from 'vue-router'
import type { MiddlewareKey } from '#build/types/middleware'

export enum EPageMiddleware {
	AUTH = 'auth',
	NO_AUTH = 'no-auth',
	ADMIN = 'admin',
	CMS = 'cms-permission',
}

export enum EPageLayout {
	PANEL = 'panel',
	MAIN = 'main',
	AUTH = 'auth',
	RESERVATION = 'reservation',
	DEFAULT = 'default',
	NAV = 'nav',
}

export const PageMiddlewareArrays: { [key: string]: (MiddlewareKey | NavigationGuard)[] } = {
	AUTH: [EPageMiddleware.AUTH],
	NO_AUTH: [EPageMiddleware.NO_AUTH],
	ADMIN: [EPageMiddleware.AUTH, EPageMiddleware.ADMIN],
	CMS: [EPageMiddleware.AUTH, EPageMiddleware.CMS],
}

export const pageMeta: { [key: string]: { [key: string]: PageMeta } } = {
	PANEL: {
		PANEL: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		PRODUCT_CATALOG: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
			title: 'Carfree',
		},
		PRODUCT_CATALOG_CARS_ID: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		PRODUCT_CATALOG_SEGMENT: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		PARAMETERS: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		PARAMETERS_ID: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		LOYALTY_PROGRAMS: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		DISCOUNT_CODES: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		DISCOUNT_CODES_ID: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		LOCATIONS: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		LOCATIONS_ID: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		GOOGLE_RATINGS: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.PANEL,
		},
		NEWS: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		NEWS_ID: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		CMS_LOCATIONS: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		CACHE_REVALIDATION: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		SUBPAGES: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		SUBPAGES_ID: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
	},
	AUTH: {
		LOGIN: {
			middleware: PageMiddlewareArrays.NO_AUTH,
			layout: EPageLayout.AUTH,
		},
		LOGOUT: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.AUTH,
		},
		REGISTER: {
			middleware: PageMiddlewareArrays.NO_AUTH,
			layout: EPageLayout.AUTH,
		},
	},
	HOME: {
		HOME: {
			middleware: undefined,
			layout: EPageLayout.AUTH,
		},
		CARS: {
			middleware: undefined,
			layout: EPageLayout.MAIN,
		},
	},
	RESERVATION: {
		RESERVATION: {
			middleware: undefined,
			layout: EPageLayout.RESERVATION,
		},
		COMPLETED: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.NAV,
		},
		CARS: {
			middleware: undefined,
			layout: EPageLayout.RESERVATION,
		},
	},
}
